import type { ReactNode } from 'react'

import { cn } from '@/utils'
import { Swatch, type SwatchProps } from './Swatch'

interface LabeledSwatchProps extends Omit<SwatchProps, 'className'> {
  label: ReactNode
  // Right-aligned, so a column of items lines its numbers up. In a content-sized box (a chart
  // tooltip) there is no free space to push into, so it just follows the label.
  value?: ReactNode
  className?: string
  swatchClassName?: string
}

// One row of a legend or status list: the swatch, what it means, and optionally the number it
// carries. The row that was being hand-rolled next to every Swatch.
export const LabeledSwatch = ({
  label,
  value,
  className,
  swatchClassName,
  ...swatch
}: LabeledSwatchProps) => (
  <div className={cn('flex min-w-0 items-center gap-1.5', className)}>
    <Swatch {...swatch} className={swatchClassName} />
    <span
      className="truncate"
      title={typeof label === 'string' ? label : undefined}
    >
      {label}
    </span>
    {value !== undefined && (
      <span className="ml-auto shrink-0 tabular-nums">{value}</span>
    )}
  </div>
)
